import MultiSelect from "react-select";

import { EditableBaseCellProps, EditableField } from "./EditableField";

export const EditableInputField = ({
  type = "text",
  ...cellProps
}: Omit<EditableBaseCellProps<string>, "ReadComponent" | "WriteComponent"> & {
  type?: React.HTMLInputTypeAttribute;
}) => (
  <EditableField
    {...cellProps}
    ReadComponent={({ value }) => <>{value || <i>vide</i>}</>}
    WriteComponent={({ value, setValue, inputRef }) => (
      <input ref={inputRef} type={type} value={value} onChange={e => setValue(e.target.value)} />
    )}
  />
);

export const EditableSelectField = <T extends string | number>({
  options,
  ...cellProps
}: Omit<EditableBaseCellProps<T>, "ReadComponent" | "WriteComponent"> & {
  options: { label: string; value: T }[];
}) => (
  <EditableField
    {...cellProps}
    ReadComponent={({ value }) => (
      <>{options.find(opt => value === opt.value)?.label || <i>vide</i>}</>
    )}
    WriteComponent={({ value, setValue, inputRef }) => (
      <select ref={inputRef} value={value} onChange={e => setValue(e.target.value as T)}>
        {options.map(opt => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    )}
  />
);

export const EditableMultiSelectField = <T extends string | number>({
  options,
  ...cellProps
}: Omit<EditableBaseCellProps<T[]>, "ReadComponent" | "WriteComponent"> & {
  options: { label: string; value: T }[];
}) => (
  <EditableField
    {...cellProps}
    ReadComponent={({ value }) => (
      <>
        {options
          .filter(opt => value.includes(opt.value))
          .map(opt => opt.label)
          .join(", ") || <i>vide</i>}
      </>
    )}
    WriteComponent={({ value, setValue, inputRef }) => (
      <MultiSelect
        isMulti
        ref={inputRef}
        value={options.filter(opt => value.includes(opt.value))}
        options={options}
        onChange={selected => setValue(selected.map(d => d.value))}
      />
    )}
  />
);

export const EditableTextAreaField = (
  cellProps: Omit<EditableBaseCellProps<string>, "ReadComponent" | "WriteComponent">
) => (
  <EditableField
    {...cellProps}
    ReadComponent={({ value }) => <>{value || <i>vide</i>}</>}
    WriteComponent={({ value, setValue, inputRef }) => (
      <textarea ref={inputRef} value={value} onChange={e => setValue(e.target.value)} />
    )}
  />
);
